module.exports = __webpack_public_path__ + "assets/img/kv-1a7ada06.jpg";